import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter"
// Handles filter dropdowns and coordinates with search inputs to update Turbo Frames
export default class extends Controller {
  static targets = ["select", "searchInput"]
  static values = {
    url: String,
    frameId: { type: String, default: "search-results" },
    searchParam: { type: String, default: "search" },
    filterParam: { type: String, default: "status" }
  }

  filter() {
    this.updateFrame()
  }

  updateFrame() {
    const url = new URL(this.urlValue, window.location.origin)
    
    // Add filter value if present
    if (this.hasSelectTarget) {
      const filterValue = this.selectTarget.value
      if (filterValue && filterValue !== "all") {
        url.searchParams.set(this.filterParamValue, filterValue)
      }
    }
    
    // Preserve search query if present
    if (this.hasSearchInputTarget) {
      const searchValue = this.searchInputTarget.value.trim()
      if (searchValue && searchValue.length >= 3) {
        url.searchParams.set(this.searchParamValue, searchValue)
      }
    }

    // Find the Turbo Frame and update its src
    const frame = document.getElementById(this.frameIdValue)
    if (frame) {
      frame.src = url.toString()
    }
  }
}
